<template>
    <div class="loading-wrapper" v-if="isActive">
        <div :class="'loading-popup popup-captcha-' + styleCaptcha">
            <div class="h-100 m-5 align-items-center text-center m-0">
                <div class="row">
                    <div class="col align-items-center d-flex" style="justify-content: center;">
                        <div class="text-center d-inline-block">
                            <h2 class="popup-title">{{ titleCaptcha }}</h2>
                            <span class="message" style="font-size: 17px">{{ $t('SecurityCode') }}</span>
                        </div>
                    </div>
                </div>

                <div class="text-center mt-1">
                    
                    <Captcha @captchaAcquired="setCaptchaKey" :regenerate="regenerateCaptcha"
                        @captchaValue="setCaptchaValue"></Captcha>
                </div>
                <span v-if="errorCaptcha" class="message" style="color: #DC3545;">{{$t('ErrorCaptcha')}}</span>
                <div class="buttons">
                    <button class="btn-confirm btn-cancel" @click="confirm()">{{ $t('Confirm') }}</button>
                    <button class="btn-cancel" @click="cancel()">{{ $t('Cancel') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Captcha from "./Captcha.vue"
export default {
    name: 'CaptchaModal',
    props: {
        rank: Number,
        active: Boolean,
        errorCaptcha: Boolean,
        styleCaptcha: String,
        titleCaptcha: String
    },
    components: {
        Captcha
    },
    data: () => ({
        regenerateCaptcha: false,
        captchaValue: "",
        captchaKey: null,
    }),
    methods: {
        confirm() {
            if(this.captchaValue.length > 0) {
                this.$emit('confirm', this.captchaKey, this.captchaValue );
                this.captchaValue = "";
            }
        },
        cancel() {
            this.$emit('cancel');
        },
        setCaptchaKey(key) {
            this.captchaKey = key;
        },
        setCaptchaValue(value) {
            this.captchaValue = value;
        },
    },
    computed: {
        isActive() {
            return this.active;
        }
    }
}
</script>

<style>
.loading-wrapper {
    background: rgba(0, 0, 0, 0.70);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
}

.loading-popup {
    width: 90%;
    min-width: 320px;
    max-width: 500px;
    background: #ffffff;
    border-radius: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding-bottom: 50px;
    color: #264076;
    z-index: 999999;
}

.loader {
    width: 50px;
    height: 50px;
}

.popup-success .popup-title {
        color: #89d24c !important;
        margin-bottom: 0px;
        font-size: 20px !important;
        display: flex;
    }

    .popup-success  .icon {
        width: 50px;
        margin: 10px 10px;
    }

    .popup-success  .message {
        color: #444;
        font-weight: lighter;
        font-size: 13px;
    }

    .popup-success  .hint {
        color: #333;
        font-weight: bold;
        font-size: 16px;
    }

    .popup-success .btn-confirm {
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 0px 0px 20px 20px;
        padding: 15px;
        width: 100%;
        border: none;
        background: #89d24c;
        color: #fff;
        font-weight: 400;
        font-size: 22px;
    }

    .popup-success .btn-confirm:not(:disabled):not(.disabled):active, .btn-confirm:not(:disabled):not(.disabled).active, .show > .btn-confirm.dropdown-toggle {
        color: #fff;
        background-color: #72b53a;
        border-color: #72b53a;
    }

    .popup-success .btn-confirm:focus, .btn-confirm.focus {
        box-shadow: none;
    }

    .popup-captcha-primary .popup-title {
    color: var(--primary) !important;
    margin-bottom: 0px;
    font-size: 20px !important;
}

.popup-captcha-primary .icon {
    width: 50px;
    margin: 10px 10px;
}

.popup-captcha-primary .message {
    color: #444;
    font-weight: lighter;
    font-size: 13px;
}

.popup-captcha-primary .hint {
    color: #333;
    font-weight: bold;
    font-size: 16px;
}

.popup-captcha-primary .btn-cancel {
    position: absolute;
    bottom: 0;
    left: 0;
    /* border-radius: 0px 0px 20px 20px; */
    padding: 15px;
    width: 50%;
    border: none;
    background: #DEE;
    color: #333;
    font-weight: 400;
    font-size: 22px;
    border-radius: 0 0 0 20px;
}

.popup-captcha-primary .btn-confirm {
    background: var(--primary);
    color: #fff;
    left: auto !important;
    right: 0 !important;
    border-radius: 0 0 20px 0;
}

.popup-captcha-primary .btn-confirm:not(:disabled):not(.disabled):active,
.btn-confirm:not(:disabled):not(.disabled).active,
.show>.btn-confirm.dropdown-toggle {
    color: #fff;
    background-color: var(--primary);
    border-color: var(--primary);
}

.popup-captcha-primary .btn-confirm:focus,
.btn-confirm.focus {
    box-shadow: none;
}
/* danger */
.popup-captcha-danger .popup-title {
    color: #DC3545 !important;
    margin-bottom: 0px;
    font-size: 20px !important;
}

.popup-captcha-danger .icon {
    width: 50px;
    margin: 10px 10px;
}

.popup-captcha-danger .message {
    color: #444;
    font-weight: lighter;
    font-size: 13px;
}

.popup-captcha-danger .hint {
    color: #333;
    font-weight: bold;
    font-size: 16px;
}

.popup-captcha-danger .btn-cancel {
    position: absolute;
    bottom: 0;
    left: 0;
    /* border-radius: 0px 0px 20px 20px; */
    padding: 15px;
    width: 50%;
    border: none;
    background: #DEE;
    color: #333;
    font-weight: 400;
    font-size: 22px;
    border-radius: 0 0 0 20px;
}

.popup-captcha-danger .btn-confirm {
    background: #DC3545;
    color: #fff;
    left: auto !important;
    right: 0 !important;
    border-radius: 0 0 20px 0;
}

.popup-captcha-danger .btn-confirm:not(:disabled):not(.disabled):active,
.btn-confirm:not(:disabled):not(.disabled).active,
.show>.btn-confirm.dropdown-toggle {
    color: #fff;
    background-color: #DC3545;
    border-color: #DC3545;
}

.popup-captcha-danger .btn-confirm:focus,
.btn-confirm.focus {
    box-shadow: none;
}

/* warn */
.popup-captcha-warn .popup-title {
    color: #ffbc34 !important;
    margin-bottom: 0px;
    font-size: 20px !important;
}

.popup-captcha-warn .icon {
    width: 50px;
    margin: 10px 10px;
}

.popup-captcha-warn .message {
    color: #444;
    font-weight: lighter;
    font-size: 13px;
}

.popup-captcha-warn .hint {
    color: #333;
    font-weight: bold;
    font-size: 16px;
}

.popup-captcha-warn .btn-cancel {
    position: absolute;
    bottom: 0;
    left: 0;
    /* border-radius: 0px 0px 20px 20px; */
    padding: 15px;
    width: 50%;
    border: none;
    background: #DEE;
    color: #333;
    font-weight: 400;
    font-size: 22px;
    border-radius: 0 0 0 20px;
}

.popup-captcha-warn .btn-confirm {
    background: #ffbc34;
    color: #fff;
    left: auto !important;
    right: 0 !important;
    border-radius: 0 0 20px 0;
}

.popup-captcha-warn .btn-confirm:not(:disabled):not(.disabled):active,
.btn-confirm:not(:disabled):not(.disabled).active,
.show>.btn-confirm.dropdown-toggle {
    color: #fff;
    background-color: #ffbc34;
    border-color: #ffbc34;
}

.popup-captcha-warn .btn-confirm:focus,
.btn-confirm.focus {
    box-shadow: none;
}
</style>